<template>

    <div class="modal modal-question fade in show" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <div class="modal-inner">
                    <div class="text-center">
                        <slot name="body"></slot>
                    </div>
                    <div class="buttons">
                        <button
                            class="btn btn_primary-outline pl-5 pr-5"
                            @click="closeModal"
                        > {{ rejectText }}</button>
                        <button
                            class="btn btn_golden"
                            @click.prevent="confirmation"
                        >
                            <span class="pl-5 pr-5">{{ confirmText }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    name: 'ActionModal',
    props: {
        confirmText: String,
        modalId: {
            type: String,
            required: true,
        },
        rejectText: String,
    },
    emits: ['confirm'],
    methods: {
        closeModal() {
            $(`#${this.modalId}`).modal('hide');
        },
        confirmation () {
            $(`#${this.modalId}`).modal('hide');
            this.$emit('confirm');
        }
    }
}

</script>



<style scoped>

</style>
